module.exports = __webpack_public_path__ + "img/img33.33a71c73.svg";